export enum KeyboardEventKeyEnums {
  ENTER = 'Enter',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
}
